import { memo } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import Button from "src/components/Buttons/Button";
import SectionHeader from "src/components/Headers/SectionHeader";
import MenuIcon from "src/components/Icons/MenuIcon";
import { toggleDocsSidebar } from "../slices/docs-sidebar-slice";

type DocsHeaderProps = {
  id: string;
  actions?: React.ReactNode;
};

/**
 * Header component for documentation pages.
 * Reuses SectionHeader with docs-specific navigation and menu toggle.
 */
function DocsHeader({ id, actions }: DocsHeaderProps) {
  const { t } = useTranslation("common");
  const dispatch = useDispatch();

  const handleToggleSidebar = () => dispatch(toggleDocsSidebar());

  return (
    <SectionHeader
      id={id}
      title={t("documentation")}
      leftAction={
        <Button className="navMenuButton" onClick={handleToggleSidebar}>
          <MenuIcon />
        </Button>
      }
    >
      {actions}
    </SectionHeader>
  );
}

export default memo(DocsHeader);
